export default {
    props: {
        noRecordsTemplate: {
            type: String | Function,
            kComposite: 'noRecords.template'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/NoRecords.js